__turbopack_context__.v({
  "container": "_2vB9-G_container",
  "fadeIn": "_2vB9-G_fadeIn",
  "fixedBorderBottom": "_2vB9-G_fixedBorderBottom",
  "placeholder": "_2vB9-G_placeholder",
  "stickyMobileSearchBar": "_2vB9-G_stickyMobileSearchBar",
});
